import PropTypes from 'prop-types';

import { Button, ModalV2 as Modal } from '@utilities';

const ModalSaveAsDraft = ({ isActive, isNonDraftSurvey, isSaving, onClose, onSubmit }) => {
  return (
    <Modal
      buttons={[
        <Button key="modal-cancel-button" onClick={onClose} text="Cancel" variant="secondary" />,
        <Button isLoading={isSaving} key="modal-save-button" onClick={onSubmit} text="Save" />,
      ]}
      isActive={isActive}
      onClose={onClose}
      title={isNonDraftSurvey ? 'Save and Exit' : 'Save as Draft and Close'}
    >
      <p>
        {isNonDraftSurvey
          ? 'Your changes will be saved before returning you to your Workspace.'
          : 'You can come back to this survey later from your saved drafts.'}
      </p>
    </Modal>
  );
};

ModalSaveAsDraft.propTypes = {
  isActive: PropTypes.bool.isRequired,
  isNonDraftSurvey: PropTypes.bool,
  isSaving: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default ModalSaveAsDraft;
